import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { styled } from '@mui/styles'
import { DateUtils, moment, muiTheme } from '@pbt/pbt-ui-components'

import Typography from '~/components/elements/Typography/Typography'
import type { QuestionTimelineItemEntry } from '~/types'

import { getAnswerDate } from './cardUtils'
import OneQuestion from './OneQuestion'

const StyledPreviousAnswersGrid = styled(Grid)(({ theme }) => ({
  borderTop: theme.constants.fabBorder,
}))

const StyledSubTextTypography = styled(Typography.Paragraph)(({ theme }) => ({
  color: theme.colors.marketingPrimary,
  display: 'inline',
  marginLeft: theme.spacing(1),
}))

const StyledDateTypography = styled(Typography.Paragraph)(() => ({
  display: 'inline',
  fontWeight: 500,
}))

const StyledPreviousTitle = styled(Typography.Paragraph)(({ theme }) => ({
  fontWeight: 500,
  color: theme.colors.brandSecondary,
}))

interface MultipleQuestionsProps {
  enableBusinessShareIcon?: boolean
  questions: QuestionTimelineItemEntry[][]
}

const MultipleQuestions = ({
  questions,
  enableBusinessShareIcon,
}: MultipleQuestionsProps) => {
  const { t } = useTranslation('Clients')

  return (
    <Grid container direction="column">
      <StyledPreviousAnswersGrid item pb={1} pl={2} pt={1}>
        <StyledPreviousTitle>
          {t('Clients:TIMELINE.QUESTION_CARD.PREVIOUS_ANSWERS')}
        </StyledPreviousTitle>
      </StyledPreviousAnswersGrid>
      <Grid container direction="column">
        {questions.map((entry) => {
          const date = getAnswerDate(entry)
          return (
            <Grid
              container
              item
              direction="column"
              key={`previous-answers for ${DateUtils.formatDate(date)}`}
              p={2}
              sx={{
                '&:nth-of-type(odd)': {
                  backgroundColor: muiTheme.colors.grayGray4,
                },
              }}
            >
              <Grid item>
                <StyledDateTypography>
                  {DateUtils.formatDate(date)}
                </StyledDateTypography>
                <StyledSubTextTypography>
                  {moment(date).fromNow()}
                </StyledSubTextTypography>
              </Grid>
              <OneQuestion
                hidePadding
                showAppointmentButton
                enableBusinessShareIcon={enableBusinessShareIcon}
                question={entry}
              />
            </Grid>
          )
        })}
      </Grid>
    </Grid>
  )
}

export default MultipleQuestions
